import { DeleteOutlined, PaperClipOutlined } from '@ant-design/icons'
import { Flex } from 'antd'
import { UploadFile } from 'antd/lib'
import cn from 'classnames'

import { Text } from 'src/components'

import { useStyles } from './styles'

type Props = {
  file: UploadFile & { id?: string }
  fileCount?: number
  onRemove?: () => void
  onDownload?: () => void
}

export const CustomItemRender = ({
  file,
  fileCount,
  onRemove,
  onDownload
}: Props) => {
  const { styles } = useStyles()

  return (
    <Flex
      className={styles.uploadItem}
      justify="space-between"
      gap={8}
      align="center"
    >
      <Flex gap={8}>
        <PaperClipOutlined className={styles.fileIcon} />
        <Text className={styles.fileName} onClick={() => onDownload?.()}>
          {file?.name}
        </Text>
      </Flex>
      {onRemove && (fileCount === undefined || fileCount > 1) && (
        <DeleteOutlined
          className={cn('pointer', styles.fileIcon)}
          size={16}
          onClick={onRemove}
        />
      )}
    </Flex>
  )
}
